import React from 'react';
import { cn } from '../../utils/cn';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'gray' | 'mesh' | 'dark';
  padding?: 'sm' | 'md' | 'lg' | 'none';
}

const backgroundStyles = {
  white: 'bg-white',
  gray: 'bg-gray-50',
  mesh: 'bg-mesh',
  dark: 'bg-hero text-white',
};

const paddingStyles = {
  none: '',
  sm: 'py-12 md:py-16',
  md: 'py-16 md:py-24',
  lg: 'py-20 md:py-32',
};

export const Section: React.FC<SectionProps> = ({
  children,
  className,
  id,
  background = 'white',
  padding = 'md',
}) => {
  return (
    <section
      id={id}
      className={cn(
        backgroundStyles[background],
        paddingStyles[padding],
        className
      )}
    >
      {children}
    </section>
  );
};

